<div class="user-stats border rounded bg-light">
  <div class="container">
    <div class="d-flex flex-row">
      <div class="flex-fill title h6 align-middle">
        My Daily Stats
      </div>

      <div class="flex-fill stat faxes border rounded">
        Faxes
        @if (faxStat) {
          <div class="count h3">
            {{ faxStat.count }}
          </div>
        } @else {
          <div class="loading">
            <fa-icon [icon]="['fas', 'circle-notch']" size="lg" [animation]="'spin'" />
          </div>
        }
      </div>

      <div class="flex-fill stat geb border rounded">
        GEB
        @if (gatherEvidenceBlockedStat) {
          <div class="count h3">
            {{ gatherEvidenceBlockedStat.count }}
          </div>
        } @else {
          <div class="loading">
            <fa-icon [icon]="['fas', 'circle-notch']" size="lg" [animation]="'spin'" />
          </div>
        }
      </div>

      <div class="flex-fill stat consult-notes border rounded">
        Consult Notes
        @if (consultNoteStat) {
          <div class="count h3">
            {{ consultNoteStat.count }}
          </div>
        } @else {
          <div class="loading">
            <fa-icon [icon]="['fas', 'circle-notch']" size="lg" [animation]="'spin'" />
          </div>
        }
      </div>

      <div class="flex-fill stat verified  border rounded">
        Verified
        @if (verifiedCaptureStat) {
          <div class="count h3">
            {{ verifiedCaptureStat.count }}
          </div>
        } @else {
          <div class="loading">
            <fa-icon [icon]="['fas', 'circle-notch']" size="lg" [animation]="'spin'" />
          </div>
        }
      </div>
    </div>
  </div>
</div>

